import { Component, DestroyRef, computed, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { ProductCardComponent } from 'shared/components/product-card/product-card.component';
import { IProduct } from 'shared/types/product.interface';

@Component({
  selector: 'app-product-list-v2',
  templateUrl: './product-list-v2.component.html',
  imports: [ProductCardComponent],
  styleUrls: ['./product-list-v2.component.scss']
})
export class ProductListV2Component {
  readonly items = input<IProduct[]>();
  readonly #translateService = inject(TranslateService);
  readonly #destroyRef = inject(DestroyRef);

  readonly currentLang = signal(this.#translateService.currentLang);
  readonly isEnglish = computed(() => this.currentLang() === 'en');

  constructor() {
    this.#translateService.onLangChange
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(event => this.currentLang.set(event.lang));
  }
}
